import { Region } from '../region';
import { IPaymentProvider } from '../../providers/payment/payment.interface'
import { PaymentProviderCyberSource } from '../../providers/payment/payment.cybersource';
import { DirectBankBrand } from '../../model/types/payment-method-type';

/**
 * @description Geographical region the application is currently configured for, e.g. US, Spain, Australia.
 * @region Enumeration for this region.
 * @defaultCountryFrom Default value to use for send-from country, i.e. in price calculator
 * @defaultCurrencyFrom Default value to use for send-from currency, i.e. in price calculator
 * @defaultLanguage Default language culture to use, i.e. content translations
 */
export const regionValues = {
  region: Region.BE,
  regionId: 1105,
  defaultCountryFrom: 'BE',
  defaultCountryFromOnfido: 'BEL',
  defaultCountryCodeFrom: 32,
  defaultCurrencyFrom: 'EUR',
  defaultLanguageCulture: 'fr-BE',
  defaultLocation: {
    latitude: 50.8503,
    longitude: 4.3517
  },
  dateFormat: 'DD/MM/YYYY',
  postalCodeRegex:`^\\d{4}$`,
  links: {
    linkFaq: 'https://www.riamoneytransfer.com/us/en/mobile-content/faqs'
  },
  languageCultures: ['fr-BE', 'en-BE', 'nl-BE'],
  regionalIp: '66.82.123.234',
  paymentProvider: <IPaymentProvider>new PaymentProviderCyberSource(),
  isPlaidEnabled: false,
  isBankAccountEnabled:false,
  useSecurityQuestions: false,
  oldRemittanceLogin: false,
  onfidoMaxAttempts: 1,
  directBankBrand: DirectBankBrand.Bancontact,
  distanceMetric: 'km',
  acceptInternationalCards:true,
  stagedRiaBrand: '',
  payNearMeBrand: '',
  isEu: true,
  isEMEA: true,
  notShowMarketingPushAlert: false,
  useVeriff: false,
  googlepayAdyenPaymentNetworks: ["masterCard", "visa"],
  applepayAdyenPaymentNetworks: ["cartes_bancaires", "masterCard", "visa"],
  adyenMerchantCapability: ["debit", "3ds", "credit"],
  walletSettings:{
    isMerchantSupportEnable:false,
  },
  defaultTranslationParams: null,
  originalCountryAllowedOnly: false,
  canShowLogosOnQRScanner: false,
  airtimeServices:{
    isAirTimeSevice:false,
    isLocalOnly:false,
  },
  passCodeLength: 6,
  showNewHomePage: true,
  walletServices:[],
  isCountrySupportDecimal: true,
  autoEnableMarketingPreference: false,
  loginRootHomePage: "activity",
  adyenRegion: 'live' // https://docs.adyen.com/development-resources/live-endpoints/#client-side-environment-region
};



// WEBPACK FOOTER //
// ./src/environment/region/BE.ts